module.exports = __webpack_public_path__ + "img/magento-migration@2x.5b50d64b.webp";